import UndoRedo, { PLUGIN_KEY } from "./undoRedo.mjs";
export { PLUGIN_KEY, UndoRedo };


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/undoRedo/index.mjs
// module id = 1558
// module chunks = 1